var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInstitution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 31.9997H32M3.66667 26.9997H30.3333M7 13.6664V26.9997M13.6667 13.6664V26.9997M20.3333 13.6664V26.9997M27 13.6664V26.9997M3.66667 12.833V11.2414C3.66677 10.9628 3.73669 10.6887 3.87004 10.4442C4.00339 10.1996 4.19591 9.99234 4.43 9.84136L16.0967 2.30803C16.3659 2.13436 16.6796 2.04199 17 2.04199C17.3204 2.04199 17.6341 2.13436 17.9033 2.30803L29.57 9.84136C29.8041 9.99234 29.9966 10.1996 30.13 10.4442C30.2633 10.6887 30.3332 10.9628 30.3333 11.2414V12.833C30.3333 13.054 30.2455 13.266 30.0893 13.4223C29.933 13.5786 29.721 13.6664 29.5 13.6664H4.5C4.27899 13.6664 4.06702 13.5786 3.91074 13.4223C3.75446 13.266 3.66667 13.054 3.66667 12.833Z",
    stroke: "#367FFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstitution);
export default __webpack_public_path__ + "static/media/icon-institution.42b3b0cd07408580d153c4f2d1e017b5.svg";
export { ForwardRef as ReactComponent };